import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Markdown } from "@/components/site/Markdown";

export default function AboutPage() {
  const [about, setAbout] = useState(null);
  useEffect(() => { api.get("/about").then((r) => setAbout(r.data)); }, []);
  return (
    <div className="max-w-2xl mx-auto pt-14 fade-up" data-testid="about-page">
      <p className="meta">About</p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
        Telling it plainly.
      </h1>
      <div className="mt-10">{about && <Markdown body={about.body} testId="about-body" />}</div>
    </div>
  );
}
